import { InjectionToken } from '@angular/core';

export const SMARTBNB_API_V1 = new InjectionToken<string>('smartbnbApiV1');
export const SMARTBNB_API_OWNERS_PORTAL = new InjectionToken<string>('smartbnbApiOwnersPortal');
